module.exports = __webpack_public_path__ + "img/preacher-mentor-3.ac29d0f0.svg";